import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-10 sm:py-14 relative" data-id="element-123">
      <div className="mx-auto max-w-3xl px-6 lg:px-8 text-center" data-id="element-124">
        <FadeIn data-id="element-125">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-126">
            ¿Estás listo para volver a dormir?
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed mb-10" data-id="element-127">
          <FadeIn delay={0.1} data-id="element-128">
            <p className="text-slate-100" data-id="element-129">Esta noche podés empezar.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-130">
            <p data-id="element-131">
              No mañana. No el lunes.{' '}
              <strong className="text-slate-100" data-id="element-132">Esta noche.</strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-133">
            <p data-id="element-134">
              Hacé clic abajo, completá tu compra y en menos de dos minutos vas
              a tener todo en tu email.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-135">
            <div className="text-base" data-id="element-136">
              <p className="text-gold-light font-medium" data-id="element-137">
                El protocolo completo.
              </p>
              <p className="text-gold-light font-medium" data-id="element-138">
                El kit de emergencia.
              </p>
              <p className="text-gold-light font-medium" data-id="element-139">La rutina express.</p>
              <p className="text-slate-100 mt-4" data-id="element-140">
                Todo listo para usar desde hoy.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-141">
          <Button href="https://amigospeludosarg.shop/cart/49098154606834:1" onClick={() => trackAddToCart()} className="text-xl py-5 px-12" data-id="element-142">
            ¡QUIERO VOLVER A DORMIR!
          </Button>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-143">
          <p className="text-sm text-slate-400 font-sans mt-6" data-id="element-144">
            Acceso inmediato — Entrega por email — Sin espera
          </p>
        </FadeIn>
      </div>
    </section>;
}